export default __webpack_public_path__ + "static/media/dettachment.55302ab6.png";